import {

    Calendar,
    Clock3,
    CheckCircle2,
    Pencil,
    Trash2,
    Phone,
    MessageCircle,
    Mail,
    MapPin,
    FileText

} from "lucide-react";

import Button from "../shared/Button";
import PriorityBadge from "./PriorityBadge";

export default function FollowupItem({

    followup,

    onComplete,

    onDelete,

    onEdit

}){

    const date=new Date(

        followup.followup_at

    );

    const now=new Date();

    const overdue=

        followup.status==="pending"

        &&

        date<now;

    function getTypeIcon(){

        switch(followup.type){

            case "call":

                return <Phone size={18}/>;

            case "meeting":

                return <MapPin size={18}/>;

            case "email":

                return <Mail size={18}/>;

            case "whatsapp":

                return <MessageCircle size={18}/>;

            default:

                return <FileText size={18}/>;

        }

    }

    return(

        <div

            className={`

                crm-followup-item

                ${

                    overdue

                    ?

                    "overdue"

                    :

                    ""

                }

                ${

                    followup.status

                    ==="completed"

                    ?

                    "completed"

                    :

                    ""

                }

            `}

        >

            <div className="crm-followup-header">

                <div className="crm-followup-type">

                    {getTypeIcon()}

                    <strong>

                        {

                            followup.type

                            ||

                            "Follow-up"

                        }

                    </strong>

                </div>

                <PriorityBadge

                    priority={

                        followup.priority

                    }

                />

            </div>

            <div className="crm-followup-meta">

                <span>

                    <Calendar size={15}/>

                    {

                        date.toLocaleDateString()

                    }

                </span>

                <span>

                    <Clock3 size={15}/>

                    {

                        date.toLocaleTimeString(

                            [],

                            {

                                hour:"2-digit",

                                minute:"2-digit"

                            }

                        )

                    }

                </span>

            </div>

            {

                followup.remark &&

                <div className="crm-followup-remark">

                    {

                        followup.remark

                    }

                </div>

            }

            <div className="crm-followup-footer">

                <span

                    className={`

                        crm-followup-status

                        ${

                            followup.status

                        }

                    `}

                >

                    {

                        overdue

                        ?

                        "Overdue"

                        :

                        followup.status

                    }

                </span>

                <div className="crm-followup-actions">

                    {

                        followup.status==="pending"

                        &&

                        <Button

                            size="sm"

                            variant="success"

                            icon={

                                <CheckCircle2 size={16}/>

                            }

                            onClick={()=>

                                onComplete?.(

                                    followup.id

                                )

                            }

                        >

                            Complete

                        </Button>

                    }

                    <Button

                        size="sm"

                        variant="secondary"

                        icon={

                            <Pencil size={16}/>

                        }

                        onClick={()=>

                            onEdit?.(

                                followup

                            )

                        }

                    >

                        Edit

                    </Button>

                    <Button

                        size="sm"

                        variant="danger"

                        icon={

                            <Trash2 size={16}/>

                        }

                        onClick={()=>

                            onDelete?.(

                                followup.id

                            )

                        }

                    >

                        Delete

                    </Button>

                </div>

            </div>

        </div>

    );

}